import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; 
import { FaDownload } from "react-icons/fa";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import { GrView } from "react-icons/gr";
import { BallTriangle } from "react-loader-spinner"; // Import the specific loader
import { useCookies } from "react-cookie";

const ViewCandidateDetails = () => {
  const navigate = useNavigate(); 
  const [candidates, setCandidates] = useState([]);
  const [filteredCandidates, setFilteredCandidates] = useState([]);
  const [searchName, setSearchName] = useState("");
  const [searchDate, setSearchDate] = useState("");
  const [searchEmail, setSearchEmail] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);
  const [reminderSent, setReminderSent] = useState(new Map()); // Track reminder status for candidates
  const [totalPages, setTotalPages] = useState(1); // Track the total number of pages
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const itemsPerPage = 10; // Show 20 candidates per page
  const [loading, setLoading] = useState(true); // Track loading state
  const color = "#3498db"; // Define loader color
  const [searchTerm, setSearchTerm] = useState("");

 const [cookies,setCookie, removeCookie] = useCookies(["authToken", "userName", "role", "team"]);

  // useEffect(() => {
  //   fetchData();
  // }, [currentPage]); 
  // Fetch data when currentPage changes

  // useEffect(() => {
  //   filterCandidates();
  // }, [searchName, searchEmail, searchDate, candidates]);


  useEffect(() => {
    fetchData();
  }, [currentPage, searchTerm]); 

// alert("i am here",loading)

//http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000
const fetchData = async () => {
  try {
    setLoading(true);
    const response = await fetch(
      `http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/CreateCandidateAccount?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}`
    );
    if (!response.ok) throw new Error("Failed to fetch data");
    const data = await response.json();
    setCandidates(data.accounts);
    setFilteredCandidates(data.accounts);
    setTotalPages(data.totalPages); 
  } catch (error) {
    console.error("Error fetching data:", error);
  } finally {
    setLoading(false);
  }
};


  const filterCandidates = () => {
    let filtered = candidates;

    // Filter by name or email
    if (searchName) {
      filtered = filtered.filter(candidate =>
        candidate?.username?.toLowerCase().includes(searchName?.toLowerCase()) ||
        
        
        candidate?.email?.toLowerCase().includes(searchName?.toLowerCase())

       
      );
      console.log(searchName,"nnn")
    }

    // Filter by date if specified
    if (searchDate) {
      filtered = filtered.filter(candidate =>
        candidate.date_of_birth === searchDate
      );
    }

    setFilteredCandidates(filtered);
  };

  const handleUsernameClick = (userid) => {
    navigate(`/candidate/${userid}`);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };



  
  const handleDelete = async (id) => {
    try {
      const response = await fetch(` http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/AllUserInfoDelete/${id}`, {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      });

      if (!response.ok) {
        throw new Error("Failed to delete candidate");
      }

      const data = await response.json();
      alert(data.message);
      fetchData(); // Refresh the candidates list after deletion
    } catch (error) {
      console.error("Error deleting candidate:", error);
      alert("An error occurred while deleting the candidate.");
    }
  };

  // Send reminder function
  const sendReminder = async (candidateEmail, candidateId) => {
    // Optimistic UI Update: immediately mark reminder as sent
    setReminderSent((prev) => {
      const newReminderSent = new Map(prev);
      newReminderSent.set(candidateId, true); // Assume reminder is sent successfully
      return newReminderSent;
    });
  
    try {
      const response = await fetch(
        " http://hr-onboarding-website-backend-LB-1197701009.us-east-1.elb.amazonaws.com:5000/send-reminder",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: candidateEmail }),
        }
      );
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Failed to send reminder: ${errorData.message}`);
      }
  
      // If the request is successful, leave the UI as is (no need to update again)
      alert("Reminder sent successfully!");
    } catch (error) {
      // If something goes wrong, revert the reminder state to false
      setReminderSent((prev) => {
        const newReminderSent = new Map(prev);
        newReminderSent.set(candidateId, false); // Revert reminder status if failed
        return newReminderSent;
      });
  
      console.error("Error sending reminder:", error);
      alert(`Failed to send reminder: ${error.message}`);
    }
  };
  
  

  const downloadData = () => {
    const doc = new jsPDF();
    const candidatesToDownload = filteredCandidates; // Get all filtered candidates
  
    const margin = 10; // Left margin
    const pageWidth = doc.internal.pageSize.width; // Get the page width
    const lineHeight = 8; // Height between lines
    const headerFontSize = 10;
    const bodyFontSize = 8;
  
    let yPosition = margin + 20; // Initial position with some space for the header
  
    // Adding headers for the table in PDF
    doc.setFontSize(headerFontSize);
    doc.text("Candidate Name", margin, yPosition);
    doc.text("Email", 60, yPosition);
    doc.text("Password", 110, yPosition);
    doc.text("Created By", 160, yPosition);
    doc.text("Status", 210, yPosition);  // Corrected "status" label for consistency
    doc.text("Date", 260, yPosition);
  
    yPosition += lineHeight; // Add spacing after header
  
    // Loop through all candidates and add them to the PDF
    candidatesToDownload.forEach((candidate) => {
      // Ensure candidate's data exists before attempting to write
      if (
        candidate.username &&
        candidate.email &&
        candidate.password &&
        candidate.hrUsername &&
        candidate.status &&
        candidate.createdAt
      ) {
        console.log("Status: ", candidate.status);  // Debugging status
        console.log("Created At: ", candidate.createdAt);  // Debugging createdAt
  
        // Check if we need to add a new page (if content exceeds the page height)
        if (yPosition > 270) {
          doc.addPage(); // Add new page
          yPosition = margin + 10; // Reset yPosition for new page
          doc.setFontSize(headerFontSize); // Set header font size again after adding a new page
  
          // Reprint headers on the new page
          doc.text("Candidate Name", margin, yPosition);
          doc.text("Email", 60, yPosition);
          doc.text("Password", 110, yPosition);
          doc.text("Created By", 160, yPosition);
          doc.text("Status", 210, yPosition);
          doc.text("Date", 260, yPosition);
  
          yPosition += lineHeight; // Move to the next line after the header
        }
  
        // Add candidate details to the PDF, incrementing the yPosition
        doc.setFontSize(bodyFontSize);
  
        // Candidate row data with adjusted x positions for each column
        doc.text(String(candidate.username), margin, yPosition);
        doc.text(String(candidate.email), 60, yPosition);
        doc.text(String(candidate.password), 110, yPosition);
        doc.text(String(candidate.hrUsername), 160, yPosition);
        doc.text(String(candidate.status), 210, yPosition); // Adjust x position for "Status"
        doc.text(String(new Date(candidate.createdAt).toLocaleDateString()), 260, yPosition); // Adjust x position for "Date"
  
        yPosition += lineHeight; // Move yPosition down for the next row
      }
    });
  
    // Save the PDF with all the data
    doc.save("candidates_full_details.pdf");
  };
  
  
  
  
  
  
  
  
  
  
  
  

  const exportToExcel = (data) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Candidates");
    XLSX.writeFile(workbook, "candidates_data.xlsx");
  };

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="mt-3  bg-white mx-auto max-w-6xl  overflow-hidden p-2">
      <h1 className="text-2xl font-bold mb-6 text-center text-blue-600">
        View Candidate Details
      </h1>

      {/* Search and Download Section */}
      <div className="flex mb-4 justify-between">
        <div className="flex space-x-2 w-full">
        <input
          type="text"
          placeholder="Search by Name or Email"
          value={searchTerm}
          onChange={handleSearchChange}
          className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 w-1/2"
        />
        </div>
        <div>
          <button
            onClick={downloadData}
            className="flex items-center gap-2 border bg-blue-500 px-4 py-2 rounded-full text-white hover:bg-blue-600 transition-colors"
          >
            <FaDownload /> Download
          </button>
        </div>
      </div>

      {/* Pagination */}
      <div className="flex justify-between mb-4">
        <button
          onClick={prevPage}
          disabled={currentPage === 1}
          className="bg-blue-500 text-white px-4 py-2 rounded-lg disabled:bg-gray-300 transition-colors"
        >
          Previous
        </button>
        <button
          onClick={nextPage}
          disabled={currentPage === totalPages}
          className="bg-blue-500 text-white px-4 py-2 rounded-lg disabled:bg-gray-300 transition-colors"
        >
          Next
        </button>
      </div>

      {/* Loader or Table */}
      {loading ? (
        <div className="flex justify-center items-center py-20">
          <div className="item">
            <BallTriangle color={color} height={200} width={100} />
          </div>
        </div>
      ) : (
        <div className="overflow-x-auto mb-5">
          <table className="min-w-full bg-white border border-gray-300 rounded-lg">
            <thead className="bg-blue-500 text-white">
              <tr>
                <th className=" py-2 text-center text-sm">Name</th>
                {cookies.role !== "67f7d873fa852258bf9a2112" && (
                <th className=" py-2 text-center text-sm">Email</th>
                )}
                  {cookies.role !== "67f7d873fa852258bf9a2112" && (
                <th className=" py-2 text-center text-sm">Password</th>
                )}
                  {cookies.role !== "67f7d873fa852258bf9a2112" && (
                <th className=" py-2 text-center text-sm">Created By</th>
                )}
                <th className=" py-2 text-center text-sm">Status</th>
                <th className=" py-2 text-center text-sm">Date</th>
                {cookies.role !== "67f7d873fa852258bf9a2112" && (  <th className=" py-2 text-center text-sm">Action</th>
                
                )}
                 {cookies.role !== "67f7d873fa852258bf9a2112" && ( 
                
                <th className=" py-2 text-center text-sm">Reminder</th>
                 )}
              </tr>
            </thead>
            <tbody>
              {filteredCandidates?.map((candidate) => (
                <tr key={candidate.userid} className="border-b ">
                  <td className="px-4 py-2">
                    <p
                      className="text-blue-500 cursor-pointer hover:underline text-center text-xs"
                      onClick={() => handleUsernameClick(candidate?._id)}
                    >
                      {candidate?.username}
                    </p>
                  </td>
                  {cookies.role !== "67f7d873fa852258bf9a2112" && (
                  <td className="px-4 py-2 text-center text-xs">{candidate?.email}</td>
                  )}
                    {cookies.role !== "67f7d873fa852258bf9a2112" && (
                  <td className="px-4 py-2 text-center text-xs">{candidate?.password}</td>
                  )}
                    {cookies.role !== "67f7d873fa852258bf9a2112" && (
                  <td className="px-4 py-2 text-center text-xs">{decodeURIComponent(candidate?.hrUsername)}</td>
                  )}
                      
                  <td className="px-4 py-2 text-center text-xs">{candidate.status}</td>
                  <td className="px-4 py-2 text-center text-xs">{new Date(candidate.createdAt).toLocaleDateString()}</td>
                  {cookies.role !== "67f7d873fa852258bf9a2112" && (
  <td className="px-4 py-2">
    <button
      onClick={() => handleDelete(candidate._id)}
      className="bg-red-500 text-white px-2 py-2 rounded-lg hover:bg-red-600 transition-colors text-xs"
    >
      Delete
    </button>
  </td>
)}
  {cookies.role !== "67f7d873fa852258bf9a2112" && (
       
                  <td className="px-2 py-2">
                    <button
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent row click
                        sendReminder(candidate?.email, candidate._id);
                      }}
                      className={`px-3 py-1 rounded-lg transition-colors duration-300 text-white text-xs ${
                        reminderSent.get(candidate._id)
                          ? "bg-green-500 hover:bg-green-600"
                          : "bg-red-500 hover:bg-red-600"
                      }`}
                    >
                      {reminderSent.get(candidate._id)
                        ? "Reminder Sent"
                        : "Send Reminder"}
                    </button>
                  </td>
                )}

                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ViewCandidateDetails;
